import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'currency'})
export class CurrencyPipe implements PipeTransform {
  transform(value: string, args?: any): any {
    if (!value) return value;

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/pipe/currency.pipe.ts